itsoftApp.createModule("animateScroll", ["headerFix"], function() {
    var module = this;
    var loaded = false;
    var pageHeader = document.querySelector(".page-header");

    var startScroll = function (el, padding) {
      if (!itsoftApp.commonVars.headerHeight) {
        itsoftApp.utils.getHeaderHeight();
      }
      $(el).animatescroll({
        padding: padding ? padding : itsoftApp.commonVars.headerHeight,
      });
    }

    var initAnimateScroll = function (el, padding) {
      if (!loaded) {
        itsoftApp.loadScript("/assets/scripts/animatescroll/animatescroll.min.js", function () {
          loaded = true;
          startScroll(el, padding);
        });
      } else {
        startScroll(el, padding);
      }
    }

    var animateScroll = $("a[href^='#']:not(a[href='#'])");

    animateScroll.click(function(evt) {
      evt.preventDefault();
      var scrollId = $(this).attr('href');
      initAnimateScroll(scrollId);
    });

    module.callback = initAnimateScroll;
});